<template>
<div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Exhibitors" childName="View Exhibitors"></side-menu>

    <div class="content">
        <div class="dashboard">
            <heading :title="'Exhibitors'"></heading>

            <select class="dropdown-filter" v-on:change="filterData">
                <option value="List of Exhibitors">List of Exhibitors</option>
                <option value="Categories">Categories</option>
                <option value="Organization Type">Organization Type</option>
            </select>

            <button @click="openPopup" class="btn">
                <img class="white_icon" src="@/assets/img/plus.svg" />Add Exhibitor
            </button>

            <div class="exhibitors">
                <div class="card" v-for="i in exhibitors" :key="i.id">
                    <p class="name">{{ i.company_name }}</p>
                    <p class="office_phone_number">{{ i.office_phone_number }}</p>
                    <p class="booth_number_one">{{ i.booth_number_one }}</p>
                    <p class="description">{{ i.address }}</p>
                    <div class="controls">
                        <img @click="deleteExhibitor(i.id)" src="@/assets/img/trash.svg" />
                        <img @click="editExhibitor(i)" src="@/assets/img/settings.svg" />
                    </div>
                </div>
            </div>

            <popup title="Add an Exhibitor" :show="showPopup">
                <div class="inputs">
                    <div class="left">
                        <div class="input">
                            <label style="font-size: 18px; font-weight: bold;">Company Information</label>
                        </div>

                    </div>

                    <div class="right">
                        <div class="input">
                            <label> Company Name </label>
                            <input type="text" v-model="exhibitor.company_name" />
                        </div>
                        <div class="input">
                            <label>Point of Contact First Name</label>
                            <input type="text" v-model="exhibitor.point_of_contact.first_name" />
                        </div>

                        <div class="input">
                            <label> Point of Contact Last Name</label>
                            <input type="text" v-model="exhibitor.point_of_contact.last_name" />
                        </div>

                        <div class="input">
                            <label> Point of Contact Email </label>
                            <input type="text" v-model="exhibitor.point_of_contact.email" />
                        </div>

                        <div class="input">
                            <label>Point of Contact Job Title </label>
                            <input type="text" v-model="exhibitor.point_of_contact.job_title" />
                        </div>

                        <div class="input">
                            <label>Full Address </label>
                            <input type="text" v-model="exhibitor.address" />
                        </div>
                        <div class="input">
                            <label>Office Phone Number</label>
                            <input type="text" v-model="exhibitor.office_phone_number" />
                        </div>

                        <div class="input">
                            <label>Mobile Phone Number</label>
                            <input type="text" v-model="exhibitor.mobile_phone_number" />
                        </div>

                        <div class="input">
                            <label>Website</label>
                            <input type="text" v-model="exhibitor.website" />
                        </div>

                    </div>

                    <div style="margin-top: 10px" class="input">
                        <label style="font-size: 18px; font-weight: bold;">Marketing Contact</label>
                    </div>

                    <div class="right">
                        <div class="input">
                            <label> Point of Contact First Name </label>
                            <input type="text" v-model="exhibitor.marketing_point_of_contact.first_name" />
                        </div>
                        <div class="input">
                            <label> Point of Contact Last Name </label>
                            <input type="text" v-model="exhibitor.marketing_point_of_contact.last_name" />
                        </div>

                        <div class="input">
                            <label> Point of Contact Email </label>
                            <input type="text" v-model="exhibitor.marketing_point_of_contact.email" />
                        </div>

                        <div class="input">
                            <label> Office Phone Number</label>
                            <input type="text" v-model="exhibitor.marketing_point_of_contact.office_phone_number" />
                        </div>

                        <div class="input">
                            <label>Mobile Phone Number</label>
                            <input type="text" v-model="exhibitor.marketing_point_of_contact.mobile_phone_number" />
                        </div>

                        <div class="input">
                            <label>Full Address </label>
                            <input type="text" v-model="exhibitor.marketing_point_of_contact.address" />
                        </div>
                    </div>
                    <br><br><br>
                    <div class="input">
                        <label style="font-size: 18px; font-weight: bold;">Billing Information</label>
                    </div>
                    <br>

                    <div class="right">
                        <div class="input">
                            <label> Point of Contact First Name </label>
                            <input type="text" v-model="exhibitor.billing_information.point_of_contact.first_name" />
                        </div>
                        <div class="input">
                            <label> Point of Contact Last Name </label>
                            <input type="text" v-model="exhibitor.billing_information.point_of_contact.last_name" />
                        </div>

                        <div class="input">
                            <label> Office Phone Number</label>
                            <input type="text" v-model="exhibitor.billing_information.point_of_contact.mobile_phone_number" />
                        </div>

                        <div class="input">
                            <label> Mobile Phone Number</label>
                            <input type="text" v-model="exhibitor.billing_information.point_of_contact.office_phone_number" />
                        </div>

                        <div class="input">
                            <label>Full Address </label>
                            <input type="text" v-model="exhibitor.billing_information.point_of_contact.address" />
                        </div>

                        <div class="input">
                            <label style="font-size: 18px; font-weight: bold;">Booth Information</label>
                        </div>

                        <div class="input">
                            <label>Booth Number (1st Choice)</label>
                            <input type="text" v-model="exhibitor.booth.booth_number" />
                        </div>

                        <div class="input">
                            <label>Booth Number (2nd Choice)</label>
                            <input type="text" v-model="exhibitor.booth.booth_number_two" />
                        </div>

                        <div class="input">
                            <label>Booth Number (3rd Choice)</label>
                            <input type="text" v-model="exhibitor.booth.booth_number_three" />
                        </div>

                        <div class="input">
                            <label>Length of Booth</label>
                            <input type="text" v-model="exhibitor.booth.length" />
                        </div>

                        <div class="input">
                            <label>Width of Booth</label>
                            <input type="text" v-model="exhibitor.booth.width" />
                        </div>

                    </div>

                    <br><br><br>
                    <div class="input" style="margin-top: 10px; width: 100%">
                        <label style="font-size: 18px; font-weight: bold;">Competitors</label>
                    </div>
                    <br>

                    <label v-for="item in exhibitors" :for="item.company_name" :key="item.id">
                        <input type="checkbox" name="exhibitors[item]" :id="item.company_name" :value="item.company_name" @change="addCompetitor(item)"> {{item.company_name}}
                    </label>

                    <br><br><br>
                    <div class="input" style="margin-top: 10px; width: 100%">
                        <label style="font-size: 18px; font-weight: bold;">Associates</label>
                    </div>
                    <br>

                    <label v-for="item in exhibitors" :for="item.company_name" :key="item.point_of_contact.first_name">
                        <input type="checkbox" name="exhibitors[item]" :id="item.company_name" :value="item.company_name" @change="addAssociate(item)"> {{item.company_name}}
                    </label>
                    <!-- -->

                    <br><br><br>
                    <div class="input" style="margin-top: 10px; width: 100%">
                        <label style="font-size: 18px; font-weight: bold;">Categories</label>
                    </div>
                    <br>

                    <label v-for="item in categories" :for="categories[item]" :key="categories[item]">
                        <input type="checkbox" name="categories[item]" :id="categories[item]" :value="categories[item]" @change="addCategory(item)"> {{item}}
                    </label>
                </div>

                <div class="btns">
                    <button @click="closePopup" class="btn text_btn">Cancel</button>
                    <button @click="addExhibitor" class="btn">Save</button>
                </div>
            </popup>

        </div>

    </div>
</div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import Upload from "@/components/Upload.vue";
import Popup from "@/components/Popup.vue";

import {
    Datetime
} from "vue-datetime";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

import Swal from "sweetalert2";

export default {
    components: {
        "btn-nav": BtnNav,
        "management-nav": managementBar,
        "side-menu": managementMenu,
        datetime: Datetime,
        heading: Title,
        popup: Popup,
        upload: Upload
    },
    data() {
        return {
            showPopup: false,
            init_edit: false,
            pageFilter: "List of Exhibitors",
            exhibitor: {
                company_name: null,
                point_of_contact: {
                    first_name: null,
                    last_name: null,
                    email: null,
                    job_title: null,
                },
                address: null,
                office_phone_number: null,
                mobile_phone_number: null,
                website: null,
                marketing_point_of_contact: {
                    first_name: null,
                    last_name: null,
                    email: null,
                    office_phone_number: null,
                    mobile_phone_number: null,
                    address: null,
                },
                booth: {
                    booth_number: null,
                    booth_number_two: null,
                    booth_number_three: null,
                    length: null,
                    width: null
                },
                billing_information: {
                    point_of_contact: {
                        first_name: null,
                        last_name: null,
                        office_phone_number: null,
                        mobile_phone_number: null,
                        address: null,
                    },
                    competitors: [],
                    associates: [],
                    categories: []
                },

            },

            exhibitors: [],
            categories: ["1", "2", "3", "4", "5"]
        };
    },
    firestore() {
        return {
            event: db.collection("event").doc(this.$route.params.id),
            exhibitors: db
                .collection("event")
                .doc(this.$route.params.id)
                .collection("exhibitors"),
        };
    },
    methods: {
        openPopup() {
            this.showPopup = true;
        },
        closePopup() {
            this.showPopup = false;

            this.exhibitor = {
                company_name: null,
                point_of_contact: {
                    first_name: null,
                    last_name: null,
                    email: null,
                    job_title: null,
                },
                address: null,
                office_phone_number: null,
                mobile_phone_number: null,
                website: null,
                marketing_point_of_contact: {
                    first_name: null,
                    last_name: null,
                    email: null,
                    office_phone_number: null,
                    mobile_phone_number: null,
                    address: null,
                },
                booth: {
                    booth_number: null,
                    booth_number_two: null,
                    booth_number_three: null,
                    length: null,
                    width: null
                },
                billing_information: {
                    point_of_contact: {
                        first_name: null,
                        last_name: null,
                        office_phone_number: null,
                        mobile_phone_number: null,
                        address: null,
                    },
                    competitors: [],
                    associates: [],
                    categories: ["1", "2", "3", "4", "5"]
                },

            }
        },
        addExhibitor() {

            let exhibitor = this.$data.exhibitor;
            let exhibitorsRef =
                // !this.init_edit ? // is NOT First time post ?
                db
                .collection("event")
                .doc(this.$route.params.id)
                .collection("exhibitors")
                .doc()
            // :
            // db
            // .collection("event")
            // .doc(this.$route.params.id)
            // .collection("exhibitors")
            // .doc(this.$route.params.i);

            exhibitorsRef
                .set(exhibitor, {
                    merge: true
                })
                .then(() => {
                    this.closePopup();
                })
                .catch((err) => console.log(err));
        },
        editExhibitor(i) {
            this.exhibitor = JSON.parse(Object.assign(JSON.stringify(i)));
            // this.exhibitor.id = i.id;
            this.showPopup = true;
            this.init_edit = true;
        },
        deleteExhibitor(id) {
            return Swal.fire({
                title: "Are you sure?",
                text: "You will not be able to undo this",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "DELETE",
                cancelButtonText: "CANCEL",
            }).then((result) => {
                if (result.value) {
                    return db
                        .collection("event")
                        .doc(this.$route.params.id)
                        .collection("exhibitors")
                        .doc(id)
                        .delete();
                }
            });
        },
        filterData(e) {
            let val = e.target.value;
            this.pageFilter == e.target.value;

            if (val == "List of Exhibitors") {
                this.exhibitors = exhibitors;
            } else if (val == "Categories") {
                exhibitors.forEach((e) => {

                    data.push(e.categrories) // is an array so two loops
                    return e.gender == val;

                    //     ,
                    //     "",
                    // "Organization Type",

                })
            }
            console.log(e.target.value)
        },
        addCompetitor(item) {
            console.log('Adding...')

            if (event.target.checked) {
                this.exhibitor.billing_information.competitors.push({
                    id: item.id,
                    id: item.company_name
                });
            } else {
                let index = this.exhibitor.billing_information.competitors.indexOf({
                    id: item.id,
                    company_name: item.company_name
                });

                this.exhibitor.billing_information.competitors.splice(index, 1);
            }

        },
        addAssociate(item) {

            if (event.target.checked) {
                this.exhibitor.billing_information.associates.push({
                    id: item.id,
                    company_name: item.company_name
                });
            } else {
                let index = this.exhibitor.billing_information.associates.indexOf({
                    id: item.id,
                    company_name: item.company_name
                });

                this.exhibitor.billing_information.associates.splice(index, 1);
            }

        },
        addCategory(item) {
            if (event.target.checked) {
                this.exhibitor.billing_information.categories.push({
                    id: item.id,
                    company_name: item.company_name
                });
            } else {
                let index = this.exhibitor.billing_information.categories.indexOf({
                    id: item.id,
                    company_name: item.company_name
                });

                this.exhibitor.billing_information.categories.splice(index, 1);
            }
        }

    }
};
</script>

<style>
.dropdown-filter {
    background-color: transparent;
    border: none;
    padding: 0 1em 0 0;
    margin: 0;
    width: 100%;
    font-family: inherit;
    font-size: 22px;
    cursor: inherit;
    line-height: inherit;
    margin-bottom: 20px;
}
</style>
